import React from 'react';
import classnames from 'classnames';
import { StageBackgroundProps } from '../types';
import EmptyBackground from '../EmptyBackground';
import { useDeviationViewContext } from '../../../Context';
import s from './Literature.scss';

export const LiteratureStageBackground: React.FC<StageBackgroundProps> = () => {
  const { isFullscreen } = useDeviationViewContext();
  return <EmptyBackground className={classnames(!isFullscreen && s['background'])} />;
};
LiteratureStageBackground.displayName = 'LiteratureStageBackground';

export default LiteratureStageBackground;
